module.exports = __webpack_public_path__ + "icons/original/large/large-a1.d73d5dfe6e49493fa72128c7d36eca4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-a1.png
// module id = QP0S
// module chunks = app